import React, { useState } from "react";
import axios from "axios";
import {
  Typography,
  Paper,
  Box,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";

const ContractUSDTBalance = () => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBalance = async () => {
    setError(null);
    setBalance(null);
    setLoading(true);

    try {
      const res = await axios.get(
        "https://api.example.com/api/v1/tronvault/contract/usdt/balance"
      );
      setBalance(res.data);
    } catch (err) {
      console.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, width:'60%',paddingX:'10%', mx: "auto", mt: 5 }}>
      <Typography
        variant="h6"
        gutterBottom
        dir="rtl"
        sx={{ textAlign: "right" }}
      >
        موجودی USDT در قرارداد TronVault
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={fetchBalance}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "دریافت موجودی"
          )}
        </Button>

        {balance !== null && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <Typography variant="subtitle2">موجودی:</Typography>
            <Typography variant="h5" color="green">
              {Number(balance).toLocaleString()} USDT
            </Typography>
          </Paper>
        )}

        {error && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <Alert severity="error">خطا</Alert>
            <pre
              style={{
                backgroundColor: "#fff0f0",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(error, null, 2)}
            </pre>
          </Paper>
        )}
      </Box>
    </Paper>
  );
};

export default ContractUSDTBalance;
